import { EntityType, EntityInstance } from "./Entities";

export interface SnackbarState {
    show: boolean;
    text: string;
    color: string;
}

export interface TableOptions {
    page: number;
    itemsPerPage: number;
    sortBy: string[];
    sortDesc: boolean[];
}

export interface FilterCountRequest {
    slot: string;
    match_key: string;
    operator: string;
    value: string;
}

export interface FilterPayload {
    filters: Array<{match_key: string, operator: string, value: string}>;
    count_requests?: FilterCountRequest[];
    counts?: { [slot: string]: number };
}

export class EntityInstancesViewScreenData {
    // Entity type data
    entityType: EntityType | null;

    // Instances list
    instances: any[];
    totalCount: number;

    // Loading states
    loading: boolean;
    saving: boolean;
    deleting: boolean;
    executingListAction: string | false;

    // Delete confirmation
    deleteConfirmDialog: boolean;
    instanceToDelete: any | null;
    selectedInstances: string[];

    // List action condition error
    conditionErrorDialog: boolean;
    conditionError: string;

    // Dialog state
    dialog: boolean;
    editingInstance: any | null;
    formPayload: Record<string, any>;

    // Filter state
    filterPayload: FilterPayload;
    showFilters: boolean;

    // Editor keys for force re-render
    editorCounter: number;
    filterEditorCounter: number;

    // Snackbar
    snackbar: SnackbarState;

    // Table pagination options
    tableOptions: TableOptions;

    // Internal flags
    initialLoadDone: boolean;
    paginationWait: boolean;
    paginationJustClicked: boolean;
    paginationLoading: boolean;

    constructor() {
        this.entityType = null;
        this.instances = [];
        this.totalCount = 0;
        this.loading = false;
        this.saving = false;
        this.deleting = false;
        this.executingListAction = false;
        this.deleteConfirmDialog = false;
        this.instanceToDelete = null;
        this.selectedInstances = [];
        this.conditionErrorDialog = false;
        this.conditionError = '';
        this.dialog = false;
        this.editingInstance = null;
        this.formPayload = {};
        this.filterPayload = { filters: [] };
        this.showFilters = false;
        this.editorCounter = 0;
        this.filterEditorCounter = 0;
        this.snackbar = {
            show: false,
            text: '',
            color: 'success'
        };
        this.tableOptions = {
            page: 1,
            itemsPerPage: 10,
            sortBy: [],
            sortDesc: []
        };
        this.initialLoadDone = false;
        this.paginationWait = false;
        this.paginationJustClicked = false;
        this.paginationLoading = false;
    }

    reset() {
        this.entityType = null;
        this.instances = [];
        this.totalCount = 0;
        this.loading = false;
        this.saving = false;
        this.deleting = false;
        this.executingListAction = false;
        this.deleteConfirmDialog = false;
        this.instanceToDelete = null;
        this.selectedInstances = [];
        this.conditionErrorDialog = false;
        this.conditionError = '';
        this.dialog = false;
        this.editingInstance = null;
        this.formPayload = {};
        this.filterPayload = { filters: [] };
        this.showFilters = false;
        this.tableOptions.page = 1;
        this.initialLoadDone = false;
    }
}
